import { AvatarSkeleton } from "@circleco/compass/components/AvatarSkeleton";
import { Skeleton } from "@circleco/compass/components/Skeleton";

import { classNames } from "@/react/helpers/twMergeWithCN";

interface MemberRowSkeletonProps {
  className?: string;
}

export const MemberRowSkeleton = ({ className }: MemberRowSkeletonProps) => (
  <div className={classNames("flex items-center gap-3", className)}>
    <AvatarSkeleton size="lg" />
    <div className="flex min-w-0 flex-1 flex-col gap-1">
      <Skeleton shape="pill" className="h-4 w-32" />
      <Skeleton shape="pill" className="h-3 w-48" />
    </div>
  </div>
);
